const orgMatchType = {
  type: 'Matrix',
  key: 'orgMatchType',
  value: 'Full'
};

export default orgMatchType;



// WEBPACK FOOTER //
// ./app/models/orgMatchTypeIntegration.js